export const apiSignature = {
  META_COUNTRY_LIST: "meta/fetchCountryList",
  META_SET_UP_BUSSINESS: "meta/setUpBussinessAPI",
  META_FETCH_SET_UP_BUSSINESS:"meta/fetchBussinessPreferenceList",
};
